// ACESSO-01 (L8b): a decisão pelo escopo `módulo:ação` fora de componente, onde não há o `useAcesso`: o guard das
// rotas, o redirecionamento de Configurações, os getters das conversas e o aviso sonoro. A regra é a do `useAcesso`,
// que a usa também: o escopo, ou a lista em que basta um, está nos escopos efetivos da pessoa na conta
// (`accounts[].acesso.escopos`, do perfil), e o super admin pode tudo.
//
// A conta vem de quem chama: o guard lê a da rota de destino (`to.params.accountId`), e não a da rota atual, que no
// primeiro carregamento ainda não tem conta.

export const temEscopo = (exigido, escopos = [], superAdmin = false) =>
  superAdmin || [exigido].flat().some(escopo => escopos.includes(escopo));

export const escoposNaConta = (user, accountId) =>
  (user?.accounts || []).find(conta => Number(conta.id) === Number(accountId))
    ?.acesso?.escopos || [];

// O `pode` da pessoa numa conta.
export const podeNaConta = (user, accountId) => exigido =>
  temEscopo(
    exigido,
    escoposNaConta(user, accountId),
    user?.type === 'SuperAdmin'
  );

// O `decide` da pessoa numa conta: com a chave ACESSO_GRANULAR ligada (o `acesso_granular` do perfil), o escopo;
// desligada, o cheque de hoje, como está.
export const decideNaConta = (user, accountId, escopo, hoje) =>
  user?.acesso_granular === true
    ? podeNaConta(user, accountId)(escopo)
    : hoje();
